const INIT_URL = '/advert/detail/init';
const LOAD_REVIEWS_URL = '/advert/detail/load-reviews';

const API_ADVERT_DETAIL_NAME = 'apiAdvertDetail';

export {
  INIT_URL,
  LOAD_REVIEWS_URL,

  API_ADVERT_DETAIL_NAME,
};
